<template>
  <div class="shops-detail-vertify">
    <ul class="vertify-form">
      <li class="form-item">
        <span class="form-item-label">店铺类型：</span>
        <div class="form-item-content">
          {{ ENTERPRISE ? '机构店铺' : '个人店铺' }}
          <span style="color:#002B9C" v-if="shopData.batchUpload">（已开通批量上传功能）</span>
        </div>
      </li>
      <li class="form-item form-item-table">
        <ul v-if="user_CERTIFIED">
          <li class="form-item-table__header">
            {{ user_ENTERPRISE ? '企业认证信息' : '个人认证信息' }}
          </li>
          <li class="form-item">
            <span class="form-item-label">
              {{ user_ENTERPRISE ? '企业名称：' : '真实姓名：' }}
            </span>
            <div class="form-item-content" style="margin-right:auto;">
              {{ cert.realName }}
            </div>
            <template v-if="user_PERSONAL">
              <span class="form-item-label">身份证号：</span>
              <div class="form-item-content">
                {{ cert.identityNo }}
              </div>
            </template>
          </li>
          <li class="form-item" v-if="user_ENTERPRISE">
            <span class="form-item-label">营业执照注册号：</span>
            <div class="form-item-content">
              {{ cert.identityNo }}
            </div>
          </li>
          <li class="form-item" v-if="user_ENTERPRISE">
            <span class="form-item-label">营业执照扫描件：</span>
            <div class="form-item-content">
              <img class="identify-card" v-preview v-pic.oauth="cert.identityUpSide" />
            </div>
          </li>
          <li class="form-item" v-if="user_PERSONAL">
            <span class="form-item-label">所属行业：</span>
            <div class="form-item-content">
              {{ cert.profession }}
            </div>
          </li>
          <li class="form-item" v-if="user_ENTERPRISE">
            <span class="form-item-label">法定代表人姓名：</span>
            <div class="form-item-content">
              {{ cert.legalPerson }}
            </div>
          </li>
          <li class="form-item" v-if="user_ENTERPRISE">
            <span class="form-item-label">法定代表人身份证号：</span>
            <div class="form-item-content">
              {{ cert.legalPersonIdentityNo }}
            </div>
          </li>
          <li class="form-item" v-if="user_ENTERPRISE">
            <span class="form-item-label">法定代表人身份证：</span>
            <div class="form-item-content">
              <img class="identify-card" v-preview v-pic.oauth="cert.legalPersonIdentityUpSide" />
              <img class="identify-card" v-preview v-pic.oauth="cert.legalPersonIdentityDownSide" />
            </div>
          </li>
          <li class="form-item" v-if="user_PERSONAL">
            <span class="form-item-label">身份证正反面：</span>
            <div class="form-item-content">
              <img class="identify-card" v-preview v-pic.oauth="cert.identityUpSide" />
              <img class="identify-card" v-preview v-pic.oauth="cert.identityDownSide" />
            </div>
          </li>
        </ul>
        <ul v-else>
          <li class="form-item-table__header">该用户未认证</li>
        </ul>
      </li>
      <li class="form-item">
        <span class="form-item-label">提交审核时间：</span>
        <div class="form-item-content" style="margin-right:90px">
          {{ shopData.createdDate }}
        </div>
        <template v-if="shopData.audits && shopData.audits.pass">
          <span class="form-item-label">审核通过开店时间：</span>
          <div class="form-item-content">
            {{ shopData.audits.timestamp }}
          </div>
        </template>
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'shopDetailVertify',
  props: ['vertifyData', 'ENTERPRISE', 'shopData'],
  computed: {
    /**
     * 此处的标识为个人认证的类型
     */
    user_PERSONAL() {
      return this.vertifyData.type === 'PERSONAL';
    },
    user_ENTERPRISE() {
      return this.vertifyData.type === 'ENTERPRISE';
    },
    user_CERTIFIED() {
      return this.vertifyData.state === 'CERTIFIED';
    },
    // vertifyData() {
    //   return {
    //     id: 10,
    //     userId: 'rccEyICYAefpoW0g',
    //     mobile: '15600099978',
    //     email: '',
    //     expired: false,
    //     enabled: true,
    //     locked: false,
    //     type: 'PERSONAL',
    //     state: 'CERTIFIED',
    //     certification: {
    //       id: 28,
    //       realName: '杜俊蒙',
    //       profession: '电力、煤气及水的生产和供应业',
    //       type: 'PERSONAL',
    //       identityNo: '410781199212165194',
    //       identityUpSide: '/images/cerifications/31/ghw51eijgfybc6eo.jpg',
    //       identityDownSide: '/images/cerifications/04/szyhfxbadar9ro5o.jpg',
    //       legalPerson: '',
    //       legalPersonIdentityNo: '',
    //       state: 'WAITING',
    //       opinion: '',
    //       createdBy: 'rccEyICYAefpoW0g',
    //       createdDate: '2021-03-12 14:34:48',
    //       modifiedBy: 'rccEyICYAefpoW0g',
    //       modifiedDate: '2021-03-12 14:34:48',
    //       deleted: 0
    //     },
    //     createdDate: '2021-03-03 09:42:16',
    //     modifiedBy: 'rccEyICYAefpoW0g',
    //     modifiedDate: '2021-03-12 14:34:48',
    //     deleted: 0
    //   };
    // },
    cert() {
      return this.user_ENTERPRISE ? this.vertifyData.enterPriseCertification || '' : this.vertifyData.certification || '';
    }
  }
};
</script>

<style lang="scss">
.shops-detail-vertify {
  display: flex;
  flex-direction: column;
  min-height: 150px;
  ul,
  li {
    list-style: none;
  }
  .vertify-form {
    background-color: white;
    border-radius: 4px;
    flex: 1;
  }
  .form-item-table {
    background-color: #f7f8fc;
    max-width: 550px;
    padding: 20px 40px;
    border-radius: 4px;
    ul {
      width: 100%;
    }
    &__header {
      height: 20px;
      font-size: 12px;
      font-weight: bold;
      color: #040b28;
      line-height: 20px;
    }
    .form-item-label {
      width: auto;
      align-self: flex-start;
    }
    .form-item-content {
      color: #8998a0;
    }
  }
}
</style>
